import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import classNames from 'classnames/bind';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import { toCapitalize } from 'yoda-site-components/lib/helpers/Utils/utils';
import { GIFT_REGISTRY_MESSAGE } from 'yoda-checkout-components/lib/common/Constants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './ShippingAddressDetails.css';

const cx = classNames.bind(styles);

const renderAddress = (address) => {
    if (!isEmpty(get(address, 'relationships.giftRegistry'))) {
        return (
            <div
                className={dt(['text-black', 'text-small'])}
                data-automation-id="at-shipping-addrs-gift-registry-label"
            >
                [{GIFT_REGISTRY_MESSAGE}]
            </div>
        );
    }
    const city = !isEmpty(address.militaryAddressType)
        ? address.militaryAddressType
        : toCapitalize(address.city);
    return (
        <div
            className={dt(['text-black', 'text-small'])}
            data-automation-id="at-shipping-addrs-city-state-zip"
            data-qm-block="true"
            data-tlprivate
        >
            {city}, {address.state} {address.zip}
        </div>
    );
};

function ShippingAddressDetails({ address, source }) {
    if (isEmpty(address)) {
        return null;
    }

    return (
        <div data-automation-id="at-shipping-address">
            <div
                data-automation-id="at-shipping-addrs-name"
                className={
                    source === 'review'
                        ? dt(['font-open-sans-semibold', 'text-medium', 'pb-0', 'mb-1'])
                        : dt(['font-open-sans-semibold', 'text-normal', 'pb-2'])
                }
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(address.firstName)} {toCapitalize(address.lastName)}
            </div>
            <div
                className={dt(['text-black', 'text-small'])}
                data-automation-id="at-shipping-addrs-company"
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(address.company)}{' '}
            </div>
            <div
                className={dt(['text-black', 'text-small'])}
                data-automation-id="at-shipping-addrs-line-one"
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(address.lineOne)}{' '}
            </div>
            <div
                className={dt(['text-black', 'text-small'])}
                data-automation-id="at-shipping-addrs-line-one"
                data-qm-block="true"
                data-tlprivate
            >
                {toCapitalize(address.lineTwo)}{' '}
            </div>
            {renderAddress(address)}
            <div
                className={`${cx('shippingPhonenumber')} ${dt([
                    'text-black',
                    'text-small',
                    '!no-underline',
                ])}`}
                is
                x-ms-format-detection="none"
                data-automation-id="at-shipping-phone-number"
                data-qm-block="true"
                data-tlprivate
            >
                {Formatter.format(address.phone, 0)}
            </div>
        </div>
    );
}

ShippingAddressDetails.defaultProps = {
    address: {
        firstName: '',
        lastName: '',
        lineOne: '',
        lineTwo: '',
        city: '',
        state: '',
        zip: '',
    },
    source: '',
};

ShippingAddressDetails.propTypes = {
    address: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    source: PropTypes.string,
};

export default ShippingAddressDetails;
